import { render, staticRenderFns } from "./pretty-list.vue?vue&type=template&id=7a799e6e&"
import script from "./pretty-list.vue?vue&type=script&lang=js&"
export * from "./pretty-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports